// // import React from "react";
// // import {
// //   FiMail,
// //   FiPhone,
// //   FiMapPin,
// //   FiClock,
// //   FiSend,
// //   FiCheckCircle,
// // } from "react-icons/fi";
// // import { motion } from "framer-motion";
// // import checklist from "../components/Checklist.jpg";

// // // Map to Mumbai (adjust as needed)
// // const OFFICE_LOCATION =
// //   "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d120201.92756512847!2d72.77242501911398!3d19.082197839710848!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b63a7a0c6ebf%3A0x8652dc65c03119e2!2sMumbai%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1689844478916!5m2!1sen!2sin";

// // // Contact methods data
// // const contactMethods = [
// //   {
// //     icon: <FiMail className="text-yellow-600" size={26} />,
// //     title: "Email Us",
// //     details: ["sundeepsingh12478@gmail.com"],
// //     action: "mailto:sundeepsingh12478@gmail.com",
// //   },
// //   {
// //     icon: <FiPhone className="text-yellow-600" size={26} />,
// //     title: "Call Us",
// //     details: ["+91 88xxxxx,"],
// //     action: "tel:8828357920,",
// //   },
// //   {
// //     icon: <FiMapPin className="text-yellow-600" size={26} />,
// //     title: "Visit Us",
// //     details: [
// //       " 2A43 Nalanda Complex, Evershine Nagar",
// //       "Malad West, Mumbai - 400064",
// //       "Maharashtra, India",
// //     ],
// //     action: "https://goo.gl/maps/SOMEVALIDMAP",
// //   },
// //   {
// //     icon: <FiClock className="text-yellow-600" size={26} />,
// //     title: "Working Hours",
// //     details: [
// //       "Mon-Fri: 10am - 7pm IST",
// //       "Sat: 10am - 2pm IST",
// //       "Sunday: Closed",
// //     ],
// //     action: null,
// //   },
// // ];

// // // Animation variants for fade-in
// // const fadeIn = {
// //   hidden: { opacity: 0, y: 40 },
// //   visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
// // };

// // const ContactPage = () => {
// //   return (
// //     <div className="font-sans text-gray-800 bg-gradient-to-br from-yellow-50 via-white to-blue-50 min-h-screen">
// //       {/* HERO SECTION */}

// //       {/* CONTACT METHODS */}
// //       {/* <section className="py-16 px-6 bg-white/95 mt-[-3rem] relative z-10 rounded-t-3xl shadow-inner">
// //         <div className="container mx-auto max-w-7xl">
// //           <motion.div
// //             initial="hidden"
// //             whileInView="visible"
// //             viewport={{ once: true }}
// //             variants={fadeIn}
// //             className="grid md:grid-cols-2 lg:grid-cols-4 gap-10"
// //           >
// //             {contactMethods.map((method, index) => (
// //               <motion.div
// //                 key={index}
// //                 whileHover={{ y: -7, boxShadow: "0 2px 24px #fde68a" }}
// //                 className="bg-gradient-to-t from-yellow-50 via-white to-blue-50 p-8 rounded-2xl border border-yellow-100 hover:border-yellow-300 transition group shadow-md flex flex-col items-center text-center"
// //               >
// //                 <div className="mb-4">{method.icon}</div>
// //                 <h3 className="text-xl font-bold mb-2 text-blue-800">
// //                   {method.title}
// //                 </h3>
// //                 <ul className="space-y-2 mb-4">
// //                   {method.details.map((d, i) => (
// //                     <li key={i} className="text-gray-700">
// //                       {d}
// //                     </li>
// //                   ))}
// //                 </ul>
// //                 {method.action && (
// //                   <a
// //                     href={method.action}
// //                     target="_blank"
// //                     rel="noopener noreferrer"
// //                     className="text-yellow-700 font-medium hover:underline flex items-center justify-center gap-1"
// //                   >
// //                     Contact Now <FiSend />
// //                   </a>
// //                 )}
// //               </motion.div>
// //             ))}
// //           </motion.div>
// //         </div>
// //       </section>
// //  */}

// //       {/* CONTACT FORM + ILLUSTRATION */}
// //       <section className="py-20 px-6 bg-gradient-to-br from-yellow-50 to-white">
// //         <div className="container mx-auto max-w-4xl">
// //           <motion.div
// //             initial="hidden"
// //             whileInView="visible"
// //             variants={fadeIn}
// //             viewport={{ once: true }}
// //             className="bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col md:flex-row"
// //           >
// //             {/* Illustration */}
// //             <motion.div
// //               initial={{ opacity: 0, x: -55 }}
// //               whileInView={{ opacity: 1, x: 0 }}
// //               viewport={{ once: true }}
// //               transition={{ type: "spring", duration: 0.9, bounce: 0.28 }}
// //               className="md:w-2/5 bg:[#aea9ff]  text-blackss p-9 flex flex-col justify-center relative items-center"
// //             >
// //               <h2 className="text-2xl font-bold mb-3">Message Our Team</h2>
// //               <p className="mb-5 opacity-95">
// //                 Fill in your details – you’ll get a reply from our Indian office
// //                 within 24 hours.
// //               </p>
// //               <motion.img
// //                 src={checklist}
// //                 alt="Contact illustration"
// //                 className="mt-4 max-w-[240px] mx-auto md:mx-0 drop-shadow-xl rounded-lg"
// //                 initial={{ opacity: 0, scale: 0.93 }}
// //                 whileInView={{ opacity: 1, scale: 1 }}
// //                 transition={{ type: "spring", duration: 0.7, delay: 0.2 }}
// //               />
// //             </motion.div>

// //             {/* Form */}
// //             <div className="md:w-3/5 p-8 bg-white">
// //               <form
// //                 className="space-y-4"
// //                 action="https://formsubmit.co/sundeepsingh12478@gmail.com"
// //                 method="POST"
// //               >
// //                 <div className="grid md:grid-cols-2 gap-4">
// //                   <div>
// //                     <label className="block text-gray-700 mb-2">
// //                       First Name*
// //                     </label>
// //                     <input
// //                       required
// //                       type="text"
// //                       name="first_name"
// //                       className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 #aea9ff #aea9ff"
// //                     />
// //                   </div>
// //                   <div>
// //                     <label className="block text-gray-700 mb-2">
// //                       Last Name*
// //                     </label>
// //                     <input
// //                       required
// //                       type="text"
// //                       name="last_name"
// //                       className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 #aea9ff"
// //                     />
// //                   </div>
// //                 </div>
// //                 <div>
// //                   <label className="block text-gray-700 mb-2">Email*</label>
// //                   <input
// //                     required
// //                     type="email"
// //                     name="email"
// //                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 #aea9ff"
// //                   />
// //                 </div>
// //                 <div>
// //                   <label className="block text-gray-700 mb-2">Phone</label>
// //                   <input
// //                     type="tel"
// //                     name="phone"
// //                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 #aea9ff"
// //                   />
// //                 </div>
// //                 <div>
// //                   <label className="block text-gray-700 mb-2">Subject*</label>
// //                   <select
// //                     required
// //                     name="subject"
// //                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 #aea9ff"
// //                   >
// //                     {/* <option value="">Select a subject</option>
// //                     <option>General Inquiry</option>
// //                     <option>Sales Question</option>
// //                     <option>Technical Support</option>
// //                     <option>Partnership</option>
// //                     <option>Other</option> */}
// //                   </select>
// //                 </div>
// //                 <div>
// //                   <label className="block text-gray-700 mb-2">Message*</label>
// //                   <textarea
// //                     required
// //                     rows="4"
// //                     name="message"
// //                     className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 #aea9ff"
// //                   ></textarea>
// //                 </div>

// //                 {/* Honeypot to prevent spam */}
// //                 <input type="text" name="_honey" style={{ display: "none" }} />
// //                 {/* Disable CAPTCHA */}
// //                 <input type="hidden" name="_captcha" value="false" />
// //                 {/* Optional: Redirect on success */}
// //                 {/* <input type="hidden" name="_next" value="https://yourdomain.com/thank-you" /> */}

// //                 <motion.button
// //                   whileHover={{ scale: 1.03 }}
// //                   whileTap={{ scale: 0.97 }}
// //                   type="submit"
// //                   className="w-full bg-#aea9ff hover:bg-#aea9ff text-blue-900 py-3 rounded-lg font-semibold flex items-center justify-center shadow"
// //                 >
// //                   Send Message <FiSend className="ml-2" />
// //                 </motion.button>
// //               </form>
// //             </div>
// //           </motion.div>
// //         </div>
// //       </section>

// //       {/* LOCATION MAP */}
// //       <section className="py-16 px-6 bg-white border-t border-b border-gray-100">
// //         <div className="container mx-auto max-w-6xl">
// //           <motion.div
// //             initial="hidden"
// //             whileInView="visible"
// //             variants={fadeIn}
// //             viewport={{ once: true }}
// //             className="text-center mb-10"
// //           >
// //             <h2 className="text-3xl font-bold mb-3 text-yellow-700">
// //               Our Office in Mumbai
// //             </h2>
// //             <p className="text-lg text-gray-600 max-w-3xl mx-auto">
// //               Visit us at our Bandra West HQ or connect remotely—our doors are
// //               open for pan-India brands.
// //             </p>
// //           </motion.div>
// //           <div className="rounded-xl overflow-hidden shadow-xl border border-yellow-100">
// //             <iframe
// //               src={OFFICE_LOCATION}
// //               width="100%"
// //               height="430"
// //               style={{ border: 0 }}
// //               allowFullScreen=""
// //               loading="lazy"
// //               title="Mumbai Office Location Map"
// //               className="rounded-xl min-w-full min-h-[340px]"
// //             ></iframe>
// //           </div>
// //         </div>
// //       </section>
// //     </div>
// //   );
// // };

// // export default ContactPage;

// import React from "react";
// import { FiMail, FiPhone, FiMapPin, FiClock, FiSend } from "react-icons/fi";
// import { motion } from "framer-motion";
// import checklist from "../components/Checklist.jpg";

// // Map to Mumbai (adjust as needed)
// const OFFICE_LOCATION =
//   "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d120201.92756512847!2d72.77242501911398!3d19.082197839710848!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b63a7a0c6ebf%3A0x8652dc65c03119e2!2sMumbai%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1689844478916!5m2!1sen!2sin";

// // Contact methods data
// const contactMethods = [
//   {
//     icon: <FiMail className="text-yellow-600" size={26} />,
//     title: "Email Us",
//     details: ["sundeepsingh12478@gmail.com"],
//     action: "mailto:sundeepsingh12478@gmail.com",
//   },
//   {
//     icon: <FiPhone className="text-yellow-600" size={26} />,
//     title: "Call Us",
//     details: ["+91 88xxxxx,"],
//     action: "tel:8828357920,",
//   },
//   {
//     icon: <FiMapPin className="text-yellow-600" size={26} />,
//     title: "Visit Us",
//     details: [
//       " 2A43 Nalanda Complex, Evershine Nagar",
//       "Malad West, Mumbai - 400064",
//       "Maharashtra, India",
//     ],
//     action: "https://goo.gl/maps/SOMEVALIDMAP",
//   },
//   {
//     icon: <FiClock className="text-yellow-600" size={26} />,
//     title: "Working Hours",
//     details: [
//       "Mon-Fri: 10am - 7pm IST",
//       "Sat: 10am - 2pm IST",
//       "Sunday: Closed",
//     ],
//     action: null,
//   },
// ];

// // Animation variants for fade-in
// const fadeIn = {
//   hidden: { opacity: 0, y: 40 },
//   visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
// };

// const ContactPage = () => {
//   return (
//     <div className="font-sans text-gray-800 bg-gradient-to-br from-yellow-50 via-white to-blue-50 min-h-screen">
//       {/* HERO SECTION */}
//       {/* Note: Hero section was not provided in the original code, so it's left as a comment */}

//       {/* CONTACT METHODS */}
//       {/* <section className="py-16 px-6 bg-white/95 mt-[-3rem] relative z-10 rounded-t-3xl shadow-inner">
//         <div className="container mx-auto max-w-7xl">
//           <motion.div
//             initial="hidden"
//             whileInView="visible"
//             viewport={{ once: true }}
//             variants={fadeIn}
//             className="grid md:grid-cols-2 lg:grid-cols-4 gap-10"
//           >
//             {contactMethods.map((method, index) => (
//               <motion.div
//                 key={index}
//                 whileHover={{ y: -7, boxShadow: "0 2px 24px #fde68a" }}
//                 className="bg-gradient-to-t from-yellow-50 via-white to-blue-50 p-8 rounded-2xl border border-yellow-100 hover:border-yellow-300 transition group shadow-md flex flex-col items-center text-center"
//               >
//                 <div className="mb-4">{method.icon}</div>
//                 <h3 className="text-xl font-bold mb-2 text-blue-800">
//                   {method.title}
//                 </h3>
//                 <ul className="space-y-2 mb-4">
//                   {method.details.map((d, i) => (
//                     <li key={i} className="text-gray-700">
//                       {d}
//                     </li>
//                   ))}
//                 </ul>
//                 {method.action && (
//                   <a
//                     href={method.action}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="text-yellow-700 font-medium hover:underline flex items-center justify-center gap-1"
//                   >
//                     Contact Now <FiSend />
//                   </a>
//                 )}
//               </motion.div>
//             ))}
//           </motion.div>
//         </div>
//       </section> */}

//       {/* CONTACT FORM + ILLUSTRATION */}
//       <section className="py-20 px-6 bg-gradient-to-br from-yellow-50 to-white">
//         <div className="container mx-auto max-w-4xl">
//           <motion.div
//             initial="hidden"
//             whileInView="visible"
//             variants={fadeIn}
//             viewport={{ once: true }}
//             className="bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col md:flex-row"
//           >
//             {/* Illustration */}
//             <motion.div
//               initial={{ opacity: 0, x: -55 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               viewport={{ once: true }}
//               transition={{ type: "spring", duration: 0.9, bounce: 0.28 }}
//               className="md:w-2/5 bg-blue-600 text-white p-9 flex flex-col justify-center relative items-center"
//             >
//               <h2 className="text-2xl font-bold mb-3">Message Our Team</h2>
//               <p className="mb-5 opacity-95">
//                 Fill in your details – you’ll get a reply from our Indian office
//                 within 24 hours.
//               </p>
//               <motion.img
//                 src={checklist}
//                 alt="Contact illustration"
//                 className="mt-4 max-w-[240px] mx-auto md:mx-0 drop-shadow-xl rounded-lg"
//                 initial={{ opacity: 0, scale: 0.93 }}
//                 whileInView={{ opacity: 1, scale: 1 }}
//                 transition={{ type: "spring", duration: 0.7, delay: 0.2 }}
//               />
//             </motion.div>

//             {/* Form */}
//             <div className="md:w-3/5 p-8 bg-white">
//               <form
//                 className="space-y-4"
//                 action="https://formsubmit.co/sundeepsingh12478@gmail.com"
//                 method="POST"
//               >
//                 <div className="grid md:grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-gray-700 mb-2">
//                       First Name*
//                     </label>
//                     <input
//                       required
//                       type="text"
//                       name="first_name"
//                       className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600"
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-gray-700 mb-2">
//                       Last Name*
//                     </label>
//                     <input
//                       required
//                       type="text"
//                       name="last_name"
//                       className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600"
//                     />
//                   </div>
//                 </div>
//                 <div>
//                   <label className="block text-gray-700 mb-2">Email*</label>
//                   <input
//                     required
//                     type="email"
//                     name="email"
//                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-gray-700 mb-2">Phone</label>
//                   <input
//                     type="tel"
//                     name="phone"
//                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-gray-700 mb-2">Subject*</label>
//                   <select
//                     required
//                     name="subject"
//                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600"
//                   >
//                     <option value="">Select a subject</option>
//                     <option>General Inquiry</option>
//                     <option>Sales Question</option>
//                     <option>Technical Support</option>
//                     <option>Partnership</option>
//                     <option>Other</option>
//                   </select>
//                 </div>
//                 <div>
//                   <label className="block text-gray-700 mb-2">Message*</label>
//                   <textarea
//                     required
//                     rows="4"
//                     name="message"
//                     className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600"
//                   ></textarea>
//                 </div>

//                 {/* Honeypot to prevent spam */}
//                 <input type="text" name="_honey" style={{ display: "none" }} />
//                 {/* Disable CAPTCHA */}
//                 <input type="hidden" name="_captcha" value="false" />
//                 {/* Optional: Redirect on success */}
//                 {/* <input type="hidden" name="_next" value="https://yourdomain.com/thank-you" /> */}

//                 <motion.button
//                   whileHover={{ scale: 1.03 }}
//                   whileTap={{ scale: 0.97 }}
//                   type="submit"
//                   className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-semibold flex items-center justify-center shadow"
//                 >
//                   Send Message <FiSend className="ml-2" />
//                 </motion.button>
//               </form>
//             </div>
//           </motion.div>
//         </div>
//       </section>

//       {/* LOCATION MAP */}
//       <section className="py-16 px-6 bg-white border-t border-b border-gray-100">
//         <div className="container mx-auto max-w-6xl">
//           <motion.div
//             initial="hidden"
//             whileInView="visible"
//             variants={fadeIn}
//             viewport={{ once: true }}
//             className="text-center mb-10"
//           >
//             <h2 className="text-3xl font-bold mb-3 text-yellow-700">
//               Our Office in Mumbai
//             </h2>
//             <p className="text-lg text-gray-600 max-w-3xl mx-auto">
//               Visit us at our Bandra West HQ or connect remotely—our doors are
//               open for pan-India brands.
//             </p>
//           </motion.div>
//           <div className="rounded-xl overflow-hidden shadow-xl border border-yellow-100">
//             <iframe
//               src={OFFICE_LOCATION}
//               width="100%"
//               height="430"
//               style={{ border: 0 }}
//               allowFullScreen=""
//               loading="lazy"
//               title="Mumbai Office Location Map"
//               className="rounded-xl min-w-full min-h-[340px]"
//             ></iframe>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default ContactPage;

// import React from "react";
// import { FiMail, FiPhone, FiMapPin, FiClock, FiSend } from "react-icons/fi";
// import { motion } from "framer-motion";
// import checklist from "../components/Checklist.jpg";

// // Map to Mumbai (adjust as needed)
// const OFFICE_LOCATION =
//   "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d120201.92756512847!2d72.77242501911398!3d19.082197839710848!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b63a7a0c6ebf%3A0x8652dc65c03119e2!2sMumbai%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1689844478916!5m2!1sen!2sin";

// // Contact methods data
// const contactMethods = [
//   {
//     icon: <FiMail className="text-yellow-600" size={26} />,
//     title: "Email Us",
//     details: ["sundeepsingh12478@gmail.com"],
//     action: "mailto:sundeepsingh12478@gmail.com",
//   },
//   {
//     icon: <FiPhone className="text-yellow-600" size={26} />,
//     title: "Call Us",
//     details: ["+91 88xxxxx,"],
//     action: "tel:8828357920,",
//   },
//   {
//     icon: <FiMapPin className="text-yellow-600" size={26} />,
//     title: "Visit Us",
//     details: [
//       " 2A43 Nalanda Complex, Evershine Nagar",
//       "Malad West, Mumbai - 400064",
//       "Maharashtra, India",
//     ],
//     action: "https://goo.gl/maps/SOMEVALIDMAP",
//   },
//   {
//     icon: <FiClock className="text-yellow-600" size={26} />,
//     title: "Working Hours",
//     details: [
//       "Mon-Fri: 10am - 7pm IST",
//       "Sat: 10am - 2pm IST",
//       "Sunday: Closed",
//     ],
//     action: null,
//   },
// ];

// // Animation variants for fade-in
// const fadeIn = {
//   hidden: { opacity: 0, y: 40 },
//   visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
// };

// const ContactPage = () => {
//   return (
//     <div className="font-sans text-gray-800 bg-gradient-to-br from-yellow-50 via-white to-blue-50 min-h-screen">
//       {/* HERO SECTION */}
//       {/* Note: Hero section was not provided in the original code, so it's left as a comment */}

//       {/* CONTACT METHODS */}
//       {/* <section className="py-16 px-6 bg-white/95 mt-[-3rem] relative z-10 rounded-t-3xl shadow-inner">
//         <div className="container mx-auto max-w-7xl">
//           <motion.div
//             initial="hidden"
//             whileInView="visible"
//             viewport={{ once: true }}
//             variants={fadeIn}
//             className="grid md:grid-cols-2 lg:grid-cols-4 gap-10"
//           >
//             {contactMethods.map((method, index) => (
//               <motion.div
//                 key={index}
//                 whileHover={{ y: -7, boxShadow: "0 2px 24px #fde68a" }}
//                 className="bg-gradient-to-t from-yellow-50 via-white to-blue-50 p-8 rounded-2xl border border-yellow-100 hover:border-yellow-300 transition group shadow-md flex flex-col items-center text-center"
//               >
//                 <div className="mb-4">{method.icon}</div>
//                 <h3 className="text-xl font-bold mb-2 text-blue-800">
//                   {method.title}
//                 </h3>
//                 <ul className="space-y-2 mb-4">
//                   {method.details.map((d, i) => (
//                     <li key={i} className="text-gray-700">
//                       {d}
//                     </li>
//                   ))}
//                 </ul>
//                 {method.action && (
//                   <a
//                     href={method.action}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="text-yellow-700 font-medium hover:underline flex items-center justify-center gap-1"
//                   >
//                     Contact Now <FiSend />
//                   </a>
//                 )}
//               </motion.div>
//             ))}
//           </motion.div>
//         </div>
//       </section> */}

//       {/* CONTACT FORM + ILLUSTRATION */}
//       <section className="py-20 px-6 bg-gradient-to-br from-yellow-50 to-white">
//         <div className="container mx-auto max-w-4xl">
//           <motion.div
//             initial="hidden"
//             whileInView="visible"
//             variants={fadeIn}
//             viewport={{ once: true }}
//             className="bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col md:flex-row"
//           >
//             {/* Illustration */}
//             <motion.div
//               initial={{ opacity: 0, x: -55 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               viewport={{ once: true }}
//               transition={{ type: "spring", duration: 0.9, bounce: 0.28 }}
//               className="md:w-2/5 bg-blue-600 text-white p-9 flex flex-col justify-center relative items-center"
//             >
//               <h2 className="text-2xl font-bold mb-3">Message Our Team</h2>
//               <p className="mb-5 opacity-95">
//                 Fill in your details – you’ll get a reply from our Indian office
//                 within 24 hours.
//               </p>
//               <motion.img
//                 src={checklist}
//                 alt="Contact illustration"
//                 className="mt-4 max-w-[240px] mx-auto md:mx-0 drop-shadow-xl rounded-lg"
//                 initial={{ opacity: 0, scale: 0.93 }}
//                 whileInView={{ opacity: 1, scale: 1 }}
//                 transition={{ type: "spring", duration: 0.7, delay: 0.2 }}
//               />
//             </motion.div>

//             {/* Form */}
//             <div className="md:w-3/5 p-8 bg-white">
//               <form
//                 className="space-y-4"
//                 action="https://formsubmit.co/sundeepsingh12478@gmail.com"
//                 method="POST"
//               >
//                 <div className="grid md:grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-gray-700 mb-2">
//                       First Name*
//                     </label>
//                     <input
//                       required
//                       type="text"
//                       name="first_name"
//                       className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600"
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-gray-700 mb-2">
//                       Last Name*
//                     </label>
//                     <input
//                       required
//                       type="text"
//                       name="last_name"
//                       className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600"
//                     />
//                   </div>
//                 </div>
//                 <div>
//                   <label className="block text-gray-700 mb-2">Email*</label>
//                   <input
//                     required
//                     type="email"
//                     name="email"
//                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-gray-700 mb-2">Phone</label>
//                   <input
//                     type="tel"
//                     name="phone"
//                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-gray-700 mb-2">Subject*</label>
//                   <input
//                     required
//                     type="text"
//                     name="subject"
//                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-gray-700 mb-2">Message*</label>
//                   <textarea
//                     required
//                     rows="4"
//                     name="message"
//                     className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600"
//                   ></textarea>
//                 </div>

//                 {/* Honeypot to prevent spam */}
//                 <input type="text" name="_honey" style={{ display: "none" }} />
//                 {/* Disable CAPTCHA */}
//                 <input type="hidden" name="_captcha" value="false" />
//                 {/* Optional: Redirect on success */}
//                 {/* <input type="hidden" name="_next" value="https://yourdomain.com/thank-you" /> */}

//                 <motion.button
//                   whileHover={{ scale: 1.03 }}
//                   whileTap={{ scale: 0.97 }}
//                   type="submit"
//                   className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-semibold flex items-center justify-center shadow"
//                 >
//                   Send Message <FiSend className="ml-2" />
//                 </motion.button>
//               </form>
//             </div>
//           </motion.div>
//         </div>
//       </section>

//       {/* LOCATION MAP */}
//       <section className="py-16 px-6 bg-white border-t border-b border-gray-100">
//         <div className="container mx-auto max-w-6xl">
//           <motion.div
//             initial="hidden"
//             whileInView="visible"
//             variants={fadeIn}
//             viewport={{ once: true }}
//             className="text-center mb-10"
//           >
//             <h2 className="text-3xl font-bold mb-3 text-yellow-700">
//               Our Office in Mumbai
//             </h2>
//             <p className="text-lg text-gray-600 max-w-3xl mx-auto">
//               Visit us at our Bandra West HQ or connect remotely—our doors are
//               open for pan-India brands.
//             </p>
//           </motion.div>
//           <div className="rounded-xl overflow-hidden shadow-xl border border-yellow-100">
//             <iframe
//               src={OFFICE_LOCATION}
//               width="100%"
//               height="430"
//               style={{ border: 0 }}
//               allowFullScreen=""
//               loading="lazy"
//               title="Mumbai Office Location Map"
//               className="rounded-xl min-w-full min-h-[340px]"
//             ></iframe>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default ContactPage;

// import React from "react";
// import { FiMail, FiPhone, FiMapPin, FiClock, FiSend } from "react-icons/fi";
// import { motion } from "framer-motion";
// import checklist from "../components/Checklist.jpg";

// // Map to Mumbai (adjust as needed)
// const OFFICE_LOCATION =
//   "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d120201.92756512847!2d72.77242501911398!3d19.082197839710848!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b63a7a0c6ebf%3A0x8652dc65c03119e2!2sMumbai%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1689844478916!5m2!1sen!2sin";

// // Contact methods data
// const contactMethods = [
//   {
//     icon: <FiMail className="text-green-600" size={28} />,
//     title: "Email Us",
//     details: ["sundeepsingh12478@gmail.com"],
//     action: "mailto:sundeepsingh12478@gmail.com",
//   },
//   {
//     icon: <FiPhone className="text-green-600" size={28} />,
//     title: "Call Us",
//     details: ["+91 88xxxxx"],
//     action: "tel:8828357920",
//   },
//   {
//     icon: <FiMapPin className="text-green-600" size={28} />,
//     title: "Visit Us",
//     details: [
//       "2A43 Nalanda Complex, Evershine Nagar",
//       "Malad West, Mumbai - 400064",
//       "Maharashtra, India",
//     ],
//     action: "https://goo.gl/maps/SOMEVALIDMAP",
//   },
//   {
//     icon: <FiClock className="text-green-600" size={28} />,
//     title: "Working Hours",
//     details: [
//       "Mon-Fri: 10am - 7pm IST",
//       "Sat: 10am - 2pm IST",
//       "Sunday: Closed",
//     ],
//   },
// ];

// // Animation variants
// const fadeIn = {
//   hidden: { opacity: 0, y: 40 },
//   visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
// };

// const ContactPage = () => {
//   return (
//     <div className="font-sans text-gray-800 bg-gradient-to-br from-green-50 via-white to-green-100 min-h-screen">
//       {/* HERO SECTION */}
//       <section className="relative py-20 text-center bg-gradient-to-r from-green-600 to-green-800 text-white">
//         <motion.div
//           initial="hidden"
//           whileInView="visible"
//           variants={fadeIn}
//           viewport={{ once: true }}
//           className="max-w-3xl mx-auto"
//         >
//           <h1 className="text-4xl md:text-5xl font-bold mb-4">Get in Touch</h1>
//           <p className="text-lg opacity-90">
//             We’d love to hear from you! Reach out to our Mumbai office or drop a
//             quick message—we’ll get back within 24 hours.
//           </p>
//         </motion.div>
//       </section>

//       {/* CONTACT METHODS */}
//       <section className="py-16 px-6 -mt-12 relative z-10">
//         <div className="container mx-auto max-w-7xl">
//           <motion.div
//             initial="hidden"
//             whileInView="visible"
//             viewport={{ once: true }}
//             variants={fadeIn}
//             className="grid md:grid-cols-2 lg:grid-cols-4 gap-8"
//           >
//             {contactMethods.map((method, index) => (
//               <motion.div
//                 key={index}
//                 whileHover={{
//                   y: -6,
//                   boxShadow: "0 8px 25px rgba(16, 185, 129, 0.3)",
//                 }}
//                 className="bg-white p-8 rounded-2xl border border-green-100 hover:border-green-300 transition group shadow-md flex flex-col items-center text-center"
//               >
//                 <div className="mb-4">{method.icon}</div>
//                 <h3 className="text-xl font-bold mb-2 text-green-800">
//                   {method.title}
//                 </h3>
//                 <ul className="space-y-1 mb-4">
//                   {method.details.map((d, i) => (
//                     <li key={i} className="text-gray-600">
//                       {d}
//                     </li>
//                   ))}
//                 </ul>
//                 {method.action && (
//                   <a
//                     href={method.action}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="text-green-700 font-medium hover:underline flex items-center justify-center gap-1"
//                   >
//                     Contact Now <FiSend />
//                   </a>
//                 )}
//               </motion.div>
//             ))}
//           </motion.div>
//         </div>
//       </section>

//       {/* CONTACT FORM + ILLUSTRATION */}
//       <section className="py-20 px-6">
//         <div className="container mx-auto max-w-5xl">
//           <motion.div
//             initial="hidden"
//             whileInView="visible"
//             variants={fadeIn}
//             viewport={{ once: true }}
//             className="bg-white rounded-2xl shadow-xl overflow-hidden flex flex-col md:flex-row"
//           >
//             {/* Illustration */}
//             <motion.div
//               initial={{ opacity: 0, x: -55 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               viewport={{ once: true }}
//               transition={{ type: "spring", duration: 0.9, bounce: 0.28 }}
//               className="md:w-2/5 bg-green-600 text-white p-10 flex flex-col justify-center items-center"
//             >
//               <h2 className="text-2xl font-bold mb-3">Message Our Team</h2>
//               <p className="mb-5 opacity-95">
//                 Fill in your details—we’ll reply from our Mumbai office within
//                 24 hours.
//               </p>
//               <motion.img
//                 src={checklist}
//                 alt="Contact illustration"
//                 className="mt-4 max-w-[240px] mx-auto rounded-lg drop-shadow-xl"
//                 initial={{ opacity: 0, scale: 0.9 }}
//                 whileInView={{ opacity: 1, scale: 1 }}
//                 transition={{ type: "spring", duration: 0.7, delay: 0.2 }}
//               />
//             </motion.div>

//             {/* Form */}
//             <div className="md:w-3/5 p-8 bg-white">
//               <form
//                 className="space-y-5"
//                 action="https://formsubmit.co/sundeepsingh12478@gmail.com"
//                 method="POST"
//               >
//                 <div className="grid md:grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-gray-700 mb-2">
//                       First Name*
//                     </label>
//                     <input
//                       required
//                       type="text"
//                       name="first_name"
//                       className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600"
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-gray-700 mb-2">
//                       Last Name*
//                     </label>
//                     <input
//                       required
//                       type="text"
//                       name="last_name"
//                       className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600"
//                     />
//                   </div>
//                 </div>
//                 <div>
//                   <label className="block text-gray-700 mb-2">Email*</label>
//                   <input
//                     required
//                     type="email"
//                     name="email"
//                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-gray-700 mb-2">Phone</label>
//                   <input
//                     type="tel"
//                     name="phone"
//                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-gray-700 mb-2">Subject*</label>
//                   <input
//                     required
//                     type="text"
//                     name="subject"
//                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-gray-700 mb-2">Message*</label>
//                   <textarea
//                     required
//                     rows="4"
//                     name="message"
//                     className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600"
//                   ></textarea>
//                 </div>

//                 {/* Honeypot */}
//                 <input type="text" name="_honey" style={{ display: "none" }} />
//                 <input type="hidden" name="_captcha" value="false" />

//                 <motion.button
//                   whileHover={{ scale: 1.03 }}
//                   whileTap={{ scale: 0.97 }}
//                   type="submit"
//                   className="w-full bg-green-600 hover:bg-green-700 text-white py-3 rounded-lg font-semibold flex items-center justify-center shadow"
//                 >
//                   Send Message <FiSend className="ml-2" />
//                 </motion.button>
//               </form>
//             </div>
//           </motion.div>
//         </div>
//       </section>

//       {/* LOCATION MAP */}
//       <section className="py-16 px-6 bg-gradient-to-br from-green-50 to-white border-t border-gray-200">
//         <div className="container mx-auto max-w-6xl">
//           <motion.div
//             initial="hidden"
//             whileInView="visible"
//             variants={fadeIn}
//             viewport={{ once: true }}
//             className="text-center mb-10"
//           >
//             <h2 className="text-3xl font-bold mb-3 text-green-700">
//               Our Office in Mumbai
//             </h2>
//             <p className="text-lg text-gray-600 max-w-3xl mx-auto">
//               Visit us at our Malad West office or connect remotely—our doors
//               are always open for collaborations across India.
//             </p>
//           </motion.div>
//           <div className="rounded-xl overflow-hidden shadow-xl border border-green-100">
//             <iframe
//               src={OFFICE_LOCATION}
//               width="100%"
//               height="430"
//               style={{ border: 0 }}
//               allowFullScreen=""
//               loading="lazy"
//               title="Mumbai Office Location Map"
//               className="rounded-xl min-w-full min-h-[340px]"
//             ></iframe>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default ContactPage;

// import React from "react";
// import { FiMail, FiPhone, FiMapPin, FiClock, FiSend } from "react-icons/fi";
// import { motion } from "framer-motion";
// import checklist from "../components/Checklist.jpg";

// // Hyderabad office location
// const OFFICE_LOCATION =
//   "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.451735198218!2d78.38221877471487!3d17.4374628022298!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93e74bdbd38f%3A0x2d3a5cfd5f7f3f0!2sHitech%20City%2C%20Hyderabad%2C%20Telangana!5e0!3m2!1sen!2sin!4v1694775123456!5m2!1sen!2sin";

// // Contact methods data
// const contactMethods = [
//   {
//     icon: <FiMail className="text-green-600" size={28} />,
//     title: "Email Us",
//     details: ["support@yourcompany.com"],
//     action: "mailto:support@yourcompany.com",
//   },
//   {
//     icon: <FiPhone className="text-green-600" size={28} />,
//     title: "Call Us",
//     details: ["+91 9876543210"],
//     action: "tel:+919876543210",
//   },
//   {
//     icon: <FiMapPin className="text-green-600" size={28} />,
//     title: "Visit Us",
//     details: [
//       "5th Floor, Tech Park",
//       "Hitech City, Hyderabad - 500081",
//       "Telangana, India",
//     ],
//     action: "https://goo.gl/maps/HyderabadTechPark",
//   },
//   {
//     icon: <FiClock className="text-green-600" size={28} />,
//     title: "Working Hours",
//     details: [
//       "Mon-Fri: 10am - 7pm IST",
//       "Sat: 10am - 2pm IST",
//       "Sunday: Closed",
//     ],
//   },
// ];

// // Animation variants
// const fadeIn = {
//   hidden: { opacity: 0, y: 40 },
//   visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
// };

// const ContactPage = () => {
//   return (
//     <div className="font-sans text-gray-800 bg-gradient-to-br from-green-50 via-sky-50 to-white min-h-screen">
//       {/* HERO SECTION */}
//       <section className="relative py-20 text-center bg-gradient-to-r from-green-600 to-sky-600 text-white">
//         <motion.div
//           initial="hidden"
//           whileInView="visible"
//           variants={fadeIn}
//           viewport={{ once: true }}
//           className="max-w-3xl mx-auto"
//         >
//           <h1 className="text-4xl md:text-5xl font-bold mb-4">Get in Touch</h1>
//           <p className="text-lg opacity-90">
//             We’d love to hear from you! Reach out to our Hyderabad office or
//             drop us a message — we’ll respond within 24 hours.
//           </p>
//         </motion.div>
//       </section>

//       {/* CONTACT METHODS */}
//       <section className="py-16 px-6 -mt-12 relative z-10">
//         <div className="container mx-auto max-w-7xl">
//           <motion.div
//             initial="hidden"
//             whileInView="visible"
//             viewport={{ once: true }}
//             variants={fadeIn}
//             className="grid md:grid-cols-2 lg:grid-cols-4 gap-8"
//           >
//             {contactMethods.map((method, index) => (
//               <motion.div
//                 key={index}
//                 whileHover={{
//                   y: -6,
//                   boxShadow: "0 8px 25px rgba(14, 165, 233, 0.3)", // skyblue pop
//                 }}
//                 className="bg-white p-8 rounded-2xl border border-sky-100 hover:border-sky-300 transition group shadow-md flex flex-col items-center text-center"
//               >
//                 <div className="mb-4">{method.icon}</div>
//                 <h3 className="text-xl font-bold mb-2 text-green-700">
//                   {method.title}
//                 </h3>
//                 <ul className="space-y-1 mb-4">
//                   {method.details.map((d, i) => (
//                     <li key={i} className="text-gray-600">
//                       {d}
//                     </li>
//                   ))}
//                 </ul>
//                 {method.action && (
//                   <a
//                     href={method.action}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="text-sky-700 font-medium hover:underline flex items-center justify-center gap-1"
//                   >
//                     Contact Now <FiSend />
//                   </a>
//                 )}
//               </motion.div>
//             ))}
//           </motion.div>
//         </div>
//       </section>

//       {/* CONTACT FORM + ILLUSTRATION */}
//       <section className="py-20 px-6">
//         <div className="container mx-auto max-w-5xl">
//           <motion.div
//             initial="hidden"
//             whileInView="visible"
//             variants={fadeIn}
//             viewport={{ once: true }}
//             className="bg-white rounded-2xl shadow-xl overflow-hidden flex flex-col md:flex-row"
//           >
//             {/* Illustration */}
//             <motion.div
//               initial={{ opacity: 0, x: -55 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               viewport={{ once: true }}
//               transition={{ type: "spring", duration: 0.9, bounce: 0.28 }}
//               className="md:w-2/5 bg-gradient-to-br from-green-600 to-sky-600 text-white p-10 flex flex-col justify-center items-center"
//             >
//               <h2 className="text-2xl font-bold mb-3">Message Our Team</h2>
//               <p className="mb-5 opacity-95">
//                 Fill in your details — our Hyderabad office will get back to you
//                 within 24 hours.
//               </p>
//               <motion.img
//                 src={checklist}
//                 alt="Contact illustration"
//                 className="mt-4 max-w-[240px] mx-auto rounded-lg drop-shadow-xl"
//                 initial={{ opacity: 0, scale: 0.9 }}
//                 whileInView={{ opacity: 1, scale: 1 }}
//                 transition={{ type: "spring", duration: 0.7, delay: 0.2 }}
//               />
//             </motion.div>

//             {/* Form */}
//             <div className="md:w-3/5 p-8 bg-white">
//               <form
//                 className="space-y-5"
//                 action="https://formsubmit.co/yourmail@gmail.com"
//                 method="POST"
//               >
//                 <div className="grid md:grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-gray-700 mb-2">
//                       First Name*
//                     </label>
//                     <input
//                       required
//                       type="text"
//                       name="first_name"
//                       className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-600"
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-gray-700 mb-2">
//                       Last Name*
//                     </label>
//                     <input
//                       required
//                       type="text"
//                       name="last_name"
//                       className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-600"
//                     />
//                   </div>
//                 </div>
//                 <div>
//                   <label className="block text-gray-700 mb-2">Email*</label>
//                   <input
//                     required
//                     type="email"
//                     name="email"
//                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-600"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-gray-700 mb-2">Phone</label>
//                   <input
//                     type="tel"
//                     name="phone"
//                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-600"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-gray-700 mb-2">Subject*</label>
//                   <input
//                     required
//                     type="text"
//                     name="subject"
//                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-600"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-gray-700 mb-2">Message*</label>
//                   <textarea
//                     required
//                     rows="4"
//                     name="message"
//                     className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-600"
//                   ></textarea>
//                 </div>

//                 {/* Honeypot */}
//                 <input type="text" name="_honey" style={{ display: "none" }} />
//                 <input type="hidden" name="_captcha" value="false" />

//                 <motion.button
//                   whileHover={{ scale: 1.03 }}
//                   whileTap={{ scale: 0.97 }}
//                   type="submit"
//                   className="w-full bg-gradient-to-r from-green-600 to-sky-600 hover:opacity-90 text-white py-3 rounded-lg font-semibold flex items-center justify-center shadow"
//                 >
//                   Send Message <FiSend className="ml-2" />
//                 </motion.button>
//               </form>
//             </div>
//           </motion.div>
//         </div>
//       </section>

//       {/* LOCATION MAP */}
//       <section className="py-16 px-6 bg-gradient-to-br from-sky-50 to-white border-t border-gray-200">
//         <div className="container mx-auto max-w-6xl">
//           <motion.div
//             initial="hidden"
//             whileInView="visible"
//             variants={fadeIn}
//             viewport={{ once: true }}
//             className="text-center mb-10"
//           >
//             <h2 className="text-3xl font-bold mb-3 text-green-700">
//               Our Office in Hyderabad
//             </h2>
//             <p className="text-lg text-gray-600 max-w-3xl mx-auto">
//               Visit us at our Hitech City office or connect remotely — our doors
//               are open for collaborations across India.
//             </p>
//           </motion.div>
//           <div className="rounded-xl overflow-hidden shadow-xl border border-sky-100">
//             <iframe
//               src={OFFICE_LOCATION}
//               width="100%"
//               height="430"
//               style={{ border: 0 }}
//               allowFullScreen=""
//               loading="lazy"
//               title="Hyderabad Office Location Map"
//               className="rounded-xl min-w-full min-h-[340px]"
//             ></iframe>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default ContactPage;

// import React from "react";
// import { FiMail, FiPhone, FiMapPin, FiClock, FiSend } from "react-icons/fi";
// import { motion } from "framer-motion";
// import { Helmet } from "react-helmet-async";
// import checklist from "../components/Checklist.jpg";

// const OFFICE_LOCATION =
//   "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.451735198218!2d78.38221877471487!3d17.4374628022298!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93e74bdbd38f%3A0x2d3a5cfd5f7f3f0!2sHitech%20City%2C%20Hyderabad%2C%20Telangana!5e0!3m2!1sen!2sin!4v1694775123456!5m2!1sen!2sin";

// const contactMethods = [
//   {
//     icon: <FiMail className="text-green-600" size={28} />,
//     title: "Email Us",
//     details: ["Info@quadranglesolutions.com"],
//     action: "mailto:Info@quadranglesolutions.com",
//   },
//   {
//     icon: <FiPhone className="text-green-600" size={28} />,
//     title: "Call Us",
//     details: ["+91 9876543210", "+91 81069 38625"],
//     action: "tel:+919876543210",
//   },
//   {
//     icon: <FiMapPin className="text-green-600" size={28} />,
//     title: "Visit Us",
//     details: [
//       "5th Floor, Tech Park",
//       "Hitech City, Hyderabad - 500081",
//       "Telangana, India",
//     ],
//     action: "https://goo.gl/maps/HyderabadTechPark",
//   },
//   {
//     icon: <FiClock className="text-green-600" size={28} />,
//     title: "Working Hours",
//     details: [
//       "Mon-Fri: 10am - 7pm IST",
//       "Sat: 10am - 2pm IST",
//       "Sunday: Closed",
//     ],
//   },
// ];

// const fadeIn = {
//   hidden: { opacity: 0, y: 40 },
//   visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
// };

// const ContactPage = () => {
//   return (
//     <div className="font-sans text-gray-800 bg-gradient-to-br from-green-50 via-sky-50 to-white min-h-screen">
//       {/* ✅ SEO Meta Tags */}
//       <Helmet>
//         <title>Contact Us | Quadrangle Solutions</title>
//         <meta
//           name="description"
//           content="Get in touch with Quadrangle Solutions. Contact our Hyderabad office via email, phone, or visit us directly. We'll respond within 24 hours."
//         />
//         <meta
//           name="keywords"
//           content="Quadrangle Solutions, Contact, Hyderabad office, shipping software, logistics software, freight software, AI logistics solutions"
//         />
//         <meta name="author" content="Quadrangle Solutions" />
//         <meta property="og:title" content="Contact Quadrangle Solutions" />
//         <meta
//           property="og:description"
//           content="Reach out to Quadrangle Solutions. Connect via email, phone, or visit our Hyderabad office. Fast and reliable support."
//         />
//         <meta property="og:type" content="website" />
//         <meta
//           property="og:url"
//           content="https://quadranglesolutions.com/contact"
//         />
//         <meta
//           property="og:image"
//           content="https://quadranglesolutions.com/og-image.jpg"
//         />
//       </Helmet>

//       {/* HERO SECTION */}
//       <section className="relative py-20 text-center bg-gradient-to-r from-green-600 to-sky-600 text-white">
//         <motion.div
//           initial="hidden"
//           whileInView="visible"
//           variants={fadeIn}
//           viewport={{ once: true }}
//           className="max-w-3xl mx-auto"
//         >
//           <h1 className="text-4xl md:text-5xl font-bold mb-4">Get in Touch</h1>
//           <p className="text-lg opacity-90">
//             We’d love to hear from you! Reach out to our Hyderabad office or
//             drop us a message — we’ll respond within 24 hours.
//           </p>
//         </motion.div>
//       </section>

//       {/* CONTACT METHODS */}
//       <section className="py-16 px-6 -mt-12 relative z-10">
//         <div className="container mx-auto max-w-7xl">
//           <motion.div
//             initial="hidden"
//             whileInView="visible"
//             viewport={{ once: true }}
//             variants={fadeIn}
//             className="grid md:grid-cols-2 lg:grid-cols-4 gap-8"
//           >
//             {contactMethods.map((method, index) => (
//               <motion.div
//                 key={index}
//                 whileHover={{
//                   y: -6,
//                   boxShadow: "0 8px 25px rgba(14, 165, 233, 0.3)",
//                 }}
//                 className="bg-white p-8 rounded-2xl border border-sky-100 hover:border-sky-300 transition group shadow-md flex flex-col items-center text-center"
//               >
//                 <div className="mb-4">{method.icon}</div>
//                 <h3 className="text-xl font-bold mb-2 text-green-700">
//                   {method.title}
//                 </h3>
//                 <ul className="space-y-1 mb-4">
//                   {method.details.map((d, i) => (
//                     <li key={i} className="text-gray-600">
//                       {d}
//                     </li>
//                   ))}
//                 </ul>
//                 {method.action && (
//                   <a
//                     href={method.action}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="text-sky-700 font-medium hover:underline flex items-center justify-center gap-1"
//                   >
//                     Contact Now <FiSend />
//                   </a>
//                 )}
//               </motion.div>
//             ))}
//           </motion.div>
//         </div>
//       </section>

//       {/* CONTACT FORM + ILLUSTRATION */}
//       <section className="py-20 px-6">
//         <div className="container mx-auto max-w-5xl">
//           <motion.div
//             initial="hidden"
//             whileInView="visible"
//             variants={fadeIn}
//             viewport={{ once: true }}
//             className="bg-white rounded-2xl shadow-xl overflow-hidden flex flex-col md:flex-row"
//           >
//             {/* Illustration */}
//             <motion.div
//               initial={{ opacity: 0, x: -55 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               viewport={{ once: true }}
//               transition={{ type: "spring", duration: 0.9, bounce: 0.28 }}
//               className="md:w-2/5 bg-gradient-to-br from-green-600 to-sky-600 text-white p-10 flex flex-col justify-center items-center"
//             >
//               <h2 className="text-2xl font-bold mb-3">Message Our Team</h2>
//               <p className="mb-5 opacity-95">
//                 Fill in your details — our Hyderabad office will get back to you
//                 within 24 hours.
//               </p>
//               <motion.img
//                 src={checklist}
//                 alt="Contact illustration"
//                 className="mt-4 max-w-[240px] mx-auto rounded-lg drop-shadow-xl"
//                 initial={{ opacity: 0, scale: 0.9 }}
//                 whileInView={{ opacity: 1, scale: 1 }}
//                 transition={{ type: "spring", duration: 0.7, delay: 0.2 }}
//               />
//             </motion.div>

//             {/* Form */}
//             <div className="md:w-3/5 p-8 bg-white">
//               <form
//                 className="space-y-5"
//                 action="https://formsubmit.co/Info@quadranglesolutions.com"
//                 method="POST"
//               >
//                 <div className="grid md:grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-gray-700 mb-2">
//                       First Name*
//                     </label>
//                     <input
//                       required
//                       type="text"
//                       name="first_name"
//                       className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-600"
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-gray-700 mb-2">
//                       Last Name*
//                     </label>
//                     <input
//                       required
//                       type="text"
//                       name="last_name"
//                       className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-600"
//                     />
//                   </div>
//                 </div>
//                 <div>
//                   <label className="block text-gray-700 mb-2">Email*</label>
//                   <input
//                     required
//                     type="email"
//                     name="email"
//                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-600"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-gray-700 mb-2">Phone</label>
//                   <input
//                     type="tel"
//                     name="phone"
//                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-600"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-gray-700 mb-2">Subject*</label>
//                   <input
//                     required
//                     type="text"
//                     name="subject"
//                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-600"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-gray-700 mb-2">Message*</label>
//                   <textarea
//                     required
//                     rows="4"
//                     name="message"
//                     className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-600"
//                   ></textarea>
//                 </div>

//                 {/* Honeypot */}
//                 <input type="text" name="_honey" style={{ display: "none" }} />
//                 <input type="hidden" name="_captcha" value="false" />

//                 <motion.button
//                   whileHover={{ scale: 1.03 }}
//                   whileTap={{ scale: 0.97 }}
//                   type="submit"
//                   className="w-full bg-gradient-to-r from-green-600 to-sky-600 hover:opacity-90 text-white py-3 rounded-lg font-semibold flex items-center justify-center shadow"
//                 >
//                   Send Message <FiSend className="ml-2" />
//                 </motion.button>
//               </form>
//             </div>
//           </motion.div>
//         </div>
//       </section>

//       {/* LOCATION MAP */}
//       <section className="py-16 px-6 bg-gradient-to-br from-sky-50 to-white border-t border-gray-200">
//         <div className="container mx-auto max-w-6xl">
//           <motion.div
//             initial="hidden"
//             whileInView="visible"
//             variants={fadeIn}
//             viewport={{ once: true }}
//             className="text-center mb-10"
//           >
//             <h2 className="text-3xl font-bold mb-3 text-green-700">
//               Our Office in Hyderabad
//             </h2>
//             <p className="text-lg text-gray-600 max-w-3xl mx-auto">
//               Visit us at our Hitech City office or connect remotely — our doors
//               are open for collaborations across India.
//             </p>
//           </motion.div>
//           <div className="rounded-xl overflow-hidden shadow-xl border border-sky-100">
//             <iframe
//               src={OFFICE_LOCATION}
//               width="100%"
//               height="430"
//               style={{ border: 0 }}
//               allowFullScreen=""
//               loading="lazy"
//               title="Hyderabad Office Location Map"
//               className="rounded-xl min-w-full min-h-[340px]"
//             ></iframe>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default ContactPage;

// import React from "react";
// import { FiMail, FiPhone, FiMapPin, FiClock, FiSend } from "react-icons/fi";
// import { motion } from "framer-motion";
// import { Helmet } from "react-helmet-async";
// import checklist from "../components/Checklist.jpg";

// const OFFICE_LOCATION =
//   "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.451735198218!2d78.38221877471487!3d17.4374628022298!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93e74bdbd38f%3A0x2d3a5cfd5f7f3f0!2sHitech%20City%2C%20Hyderabad%2C%20Telangana!5e0!3m2!1sen!2sin!4v1694775123456!5m2!1sen!2sin";

// const contactMethods = [
//   {
//     icon: <FiMail className="text-green-600" size={28} />,
//     title: "Email Us",
//     details: ["Info@quadranglesolutions.com"],
//     action: "mailto:Info@quadranglesolutions.com",
//   },
//   {
//     icon: <FiPhone className="text-green-600" size={28} />,
//     title: "Call Us",
//     details: ["+91 81069 38625"],
//     action: "tel:+91 81069 38625",
//   },
//   {
//     icon: <FiMapPin className="text-green-600" size={28} />,
//     title: "Visit Us",
//     details: ["Hyderabad - 500081", "Telangana, India"],
//     action: "https://goo.gl/maps/HyderabadTechPark",
//   },
//   {
//     icon: <FiClock className="text-green-600" size={28} />,
//     title: "Working Hours",
//     details: [
//       "Mon-Fri: 10am - 7pm IST",
//       "Sat: 10am - 2pm IST",
//       "Sunday: Closed",
//     ],
//   },
// ];

// const fadeIn = {
//   hidden: { opacity: 0, y: 40 },
//   visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
// };

// const ContactPage = () => {
//   return (
//     <div className="font-sans text-gray-800 bg-gradient-to-br from-green-50 via-sky-50 to-white min-h-screen">
//       {/* ✅ SEO Meta Tags */}
//       <Helmet>
//         <title>Contact Us | Quadrangle Solutions</title>
//         <meta
//           name="description"
//           content="Get in touch with Quadrangle Solutions. Contact our Hyderabad office via email, phone, or visit us directly. We'll respond within 24 hours."
//         />
//         <meta
//           name="keywords"
//           content="Quadrangle Solutions, Contact, Hyderabad office, shipping software, logistics software, freight software, AI logistics solutions"
//         />
//         <meta name="author" content="Quadrangle Solutions" />
//       </Helmet>

//       {/* HERO SECTION */}
//       <section className="relative py-20 text-center bg-gradient-to-r from-green-600 to-sky-600 text-white">
//         <motion.div
//           initial="hidden"
//           whileInView="visible"
//           variants={fadeIn}
//           viewport={{ once: true }}
//           className="max-w-3xl mx-auto"
//         >
//           <h1 className="text-4xl md:text-5xl font-bold mb-4">Get in Touch</h1>
//           <p className="text-lg opacity-90">
//             We’d love to hear from you! Reach out to our Hyderabad office or
//             drop us a message — we’ll respond within 24 hours.
//           </p>
//         </motion.div>
//       </section>

//       {/* CONTACT METHODS */}
//       <section className="py-16 px-6 -mt-12 relative z-10">
//         <div className="container mx-auto max-w-7xl">
//           <motion.div
//             initial="hidden"
//             whileInView="visible"
//             viewport={{ once: true }}
//             variants={fadeIn}
//             className="grid md:grid-cols-2 lg:grid-cols-4 gap-8"
//           >
//             {contactMethods.map((method, index) => (
//               <motion.div
//                 key={index}
//                 whileHover={{
//                   y: -6,
//                   boxShadow: "0 8px 25px rgba(14, 165, 233, 0.3)",
//                 }}
//                 className="bg-white p-8 rounded-2xl border border-sky-100 hover:border-sky-300 transition group shadow-md flex flex-col items-center text-center"
//               >
//                 <div className="mb-4">{method.icon}</div>
//                 <h3 className="text-xl font-bold mb-2 text-green-700">
//                   {method.title}
//                 </h3>
//                 <ul className="space-y-1 mb-4">
//                   {method.details.map((d, i) => (
//                     <li key={i} className="text-gray-600">
//                       {d}
//                     </li>
//                   ))}
//                 </ul>
//                 {method.action && (
//                   <a
//                     href={method.action}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="text-sky-700 font-medium hover:underline flex items-center justify-center gap-1"
//                   >
//                     Contact Now <FiSend />
//                   </a>
//                 )}
//               </motion.div>
//             ))}
//           </motion.div>
//         </div>
//       </section>

//       {/* CONTACT FORM + ILLUSTRATION */}
//       <section className="py-20 px-6">
//         <div className="container mx-auto max-w-5xl">
//           <motion.div
//             initial="hidden"
//             whileInView="visible"
//             variants={fadeIn}
//             viewport={{ once: true }}
//             className="bg-white rounded-2xl shadow-xl overflow-hidden flex flex-col md:flex-row"
//           >
//             {/* Illustration */}
//             <motion.div
//               initial={{ opacity: 0, x: -55 }}
//               whileInView={{ opacity: 1, x: 0 }}
//               viewport={{ once: true }}
//               transition={{ type: "spring", duration: 0.9, bounce: 0.28 }}
//               className="md:w-2/5 bg-gradient-to-br from-green-600 to-sky-600 text-white p-10 flex flex-col justify-center items-center"
//             >
//               <h2 className="text-2xl font-bold mb-3">Message Our Team</h2>
//               <p className="mb-5 opacity-95">
//                 Fill in your details — our Hyderabad office will get back to you
//                 within 24 hours.
//               </p>
//               <motion.img
//                 src={checklist}
//                 alt="Contact illustration"
//                 className="mt-4 max-w-[240px] mx-auto rounded-lg drop-shadow-xl"
//                 initial={{ opacity: 0, scale: 0.9 }}
//                 whileInView={{ opacity: 1, scale: 1 }}
//                 transition={{ type: "spring", duration: 0.7, delay: 0.2 }}
//               />
//             </motion.div>

//             {/* Form */}
//             <div className="md:w-3/5 p-8 bg-white">
//               <form
//                 className="space-y-5"
//                 // action="https://formsubmit.co/Info@quadranglesolutions.com"
//                 action="https://formsubmit.co/mj1898520@gmail.com"
//                 method="POST"
//               >
//                 {/* FormSubmit hidden fields */}
//                 <input type="hidden" name="_captcha" value="false" />
//                 <input
//                   type="hidden"
//                   name="_next"
//                   value="https://quadranglesolutions.com/thank-you"
//                 />

//                 <div className="grid md:grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-gray-700 mb-2">
//                       First Name*
//                     </label>
//                     <input
//                       required
//                       type="text"
//                       name="first_name"
//                       className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-600"
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-gray-700 mb-2">
//                       Last Name*
//                     </label>
//                     <input
//                       required
//                       type="text"
//                       name="last_name"
//                       className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-600"
//                     />
//                   </div>
//                 </div>
//                 <div>
//                   <label className="block text-gray-700 mb-2">Email*</label>
//                   <input
//                     required
//                     type="email"
//                     name="email"
//                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-600"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-gray-700 mb-2">Phone</label>
//                   <input
//                     type="tel"
//                     name="phone"
//                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-600"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-gray-700 mb-2">Subject*</label>
//                   <input
//                     required
//                     type="text"
//                     name="subject"
//                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-600"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-gray-700 mb-2">Message*</label>
//                   <textarea
//                     required
//                     rows="4"
//                     name="message"
//                     className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-600"
//                   ></textarea>
//                 </div>

//                 {/* Honeypot */}
//                 <input type="text" name="_honey" style={{ display: "none" }} />

//                 <motion.button
//                   whileHover={{ scale: 1.03 }}
//                   whileTap={{ scale: 0.97 }}
//                   type="submit"
//                   className="w-full bg-gradient-to-r from-green-600 to-sky-600 hover:opacity-90 text-white py-3 rounded-lg font-semibold flex items-center justify-center shadow"
//                 >
//                   Send Message <FiSend className="ml-2" />
//                 </motion.button>
//               </form>
//             </div>
//           </motion.div>
//         </div>
//       </section>

//       {/* LOCATION MAP */}
//       <section className="py-16 px-6 bg-gradient-to-br from-sky-50 to-white border-t border-gray-200">
//         <div className="container mx-auto max-w-6xl">
//           <motion.div
//             initial="hidden"
//             whileInView="visible"
//             variants={fadeIn}
//             viewport={{ once: true }}
//             className="text-center mb-10"
//           >
//             <h2 className="text-3xl font-bold mb-3 text-green-700">
//               Our Office in Hyderabad
//             </h2>
//             <p className="text-lg text-gray-600 max-w-3xl mx-auto">
//               Visit us at our Hitech City office or connect remotely — our doors
//               are open for collaborations across India.
//             </p>
//           </motion.div>
//           <div className="rounded-xl overflow-hidden shadow-xl border border-sky-100">
//             <iframe
//               src={OFFICE_LOCATION}
//               width="100%"
//               height="430"
//               style={{ border: 0 }}
//               allowFullScreen=""
//               loading="lazy"
//               title="Hyderabad Office Location Map"
//               className="rounded-xl min-w-full min-h-[340px]"
//             ></iframe>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default ContactPage;

import React, { useState } from "react";
import { FiMail, FiPhone, FiMapPin, FiClock, FiSend } from "react-icons/fi";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";
import checklist from "../components/Checklist.jpg";

const OFFICE_LOCATION =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.451735198218!2d78.38221877471487!3d17.4374628022298!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93e74bdbd38f%3A0x2d3a5cfd5f7f3f0!2sHitech%20City%2C%20Hyderabad%2C%20Telangana!5e0!3m2!1sen!2sin!4v1694775123456!5m2!1sen!2sin";

const contactMethods = [
  {
    icon: <FiMail className="text-green-600" size={28} />,
    title: "Email Us",
    details: ["Info@quadranglesolutions.com"],
    action: "mailto:Info@quadranglesolutions.com",
  },
  {
    icon: <FiPhone className="text-green-600" size={28} />,
    title: "Call Us",
    details: ["+91 81069 38625"],
    action: "tel:+918106938625",
  },
  {
    icon: <FiMapPin className="text-green-600" size={28} />,
    title: "Visit Us",
    details: ["Hyderabad - 500081", "Telangana, India"],
    action: "https://goo.gl/maps/HyderabadTechPark",
  },
  {
    icon: <FiClock className="text-green-600" size={28} />,
    title: "Working Hours",
    details: [
      "Mon-Fri: 10am - 7pm IST",
      "Sat: 10am - 2pm IST",
      "Sunday: Closed",
    ],
  },
];

const fadeIn = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
};

const ContactPage = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const form = e.target;
    const formData = new FormData(form);

    try {
      const response = await fetch(
        "https://formsubmit.co/Info@quadranglesolutions.com",
        {
          method: "POST",
          headers: { Accept: "application/json" },
          body: formData,
        }
      );

      if (response.ok) {
        setSuccess(true);
        form.reset();
        setTimeout(() => {
          window.location.href = "https://quadranglesolutions.com/thank-you";
        }, 1500);
      } else {
        alert("Failed to send message. Please try again.");
      }
    } catch (error) {
      alert("Error sending message: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="font-sans text-gray-800 bg-gradient-to-br from-green-50 via-sky-50 to-white min-h-screen">
      {/* SEO Meta Tags */}
      <Helmet>
        <title>Contact Us | Quadrangle Solutions</title>
        <meta
          name="description"
          content="Get in touch with Quadrangle Solutions. Contact our Hyderabad office via email, phone, or visit us directly. We'll respond within 24 hours."
        />
        <meta
          name="keywords"
          content="Quadrangle Solutions, Contact, Hyderabad office, shipping software, logistics software, freight software, AI logistics solutions"
        />
        <meta name="author" content="Quadrangle Solutions" />
      </Helmet>

      {/* HERO SECTION */}
      <section className="relative py-20 text-center bg-gradient-to-r from-green-600 to-sky-600 text-white">
        <motion.div
          initial="hidden"
          whileInView="visible"
          variants={fadeIn}
          viewport={{ once: true }}
          className="max-w-3xl mx-auto"
        >
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Get in Touch</h1>
          <p className="text-lg opacity-90">
            We’d love to hear from you! Reach out to our Hyderabad office or
            drop us a message — we’ll respond within 24 hours.
          </p>
        </motion.div>
      </section>

      {/* CONTACT METHODS */}
      <section className="py-16 px-6 -mt-12 relative z-10">
        <div className="container mx-auto max-w-7xl">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeIn}
            className="grid md:grid-cols-2 lg:grid-cols-4 gap-8"
          >
            {contactMethods.map((method, index) => (
              <motion.div
                key={index}
                whileHover={{
                  y: -6,
                  boxShadow: "0 8px 25px rgba(14, 165, 233, 0.3)",
                }}
                className="bg-white p-8 rounded-2xl border border-sky-100 hover:border-sky-300 transition group shadow-md flex flex-col items-center text-center"
              >
                <div className="mb-4">{method.icon}</div>
                <h3 className="text-xl font-bold mb-2 text-green-700">
                  {method.title}
                </h3>
                <ul className="space-y-1 mb-4">
                  {method.details.map((d, i) => (
                    <li key={i} className="text-gray-600">
                      {d}
                    </li>
                  ))}
                </ul>
                {method.action && (
                  <a
                    href={method.action}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sky-700 font-medium hover:underline flex items-center justify-center gap-1"
                  >
                    Contact Now <FiSend />
                  </a>
                )}
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* CONTACT FORM + ILLUSTRATION */}
      <section className="py-20 px-6">
        <div className="container mx-auto max-w-5xl">
          <motion.div
            initial="hidden"
            whileInView="visible"
            variants={fadeIn}
            viewport={{ once: true }}
            className="bg-white rounded-2xl shadow-xl overflow-hidden flex flex-col md:flex-row"
          >
            {/* Illustration */}
            <motion.div
              initial={{ opacity: 0, x: -55 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ type: "spring", duration: 0.9, bounce: 0.28 }}
              className="md:w-2/5 bg-gradient-to-br from-green-600 to-sky-600 text-white p-10 flex flex-col justify-center items-center"
            >
              <h2 className="text-2xl font-bold mb-3">Message Our Team</h2>
              <p className="mb-5 opacity-95">
                Fill in your details — our Hyderabad office will get back to you
                within 24 hours.
              </p>
              <motion.img
                src={checklist}
                alt="Contact illustration"
                className="mt-4 max-w-[240px] mx-auto rounded-lg drop-shadow-xl"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ type: "spring", duration: 0.7, delay: 0.2 }}
              />
            </motion.div>

            {/* Form */}
            <div className="md:w-3/5 p-8 bg-white">
              <form className="space-y-5" onSubmit={handleSubmit}>
                {/* Hidden Fields */}
                <input type="hidden" name="_captcha" value="false" />
                <input
                  type="hidden"
                  name="_next"
                  value="https://quadranglesolutions.com/thank-you"
                />
                <input type="text" name="_honey" style={{ display: "none" }} />

                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-gray-700 mb-2">
                      First Name*
                    </label>
                    <input
                      required
                      type="text"
                      name="first_name"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-600"
                    />
                  </div>
                  <div>
                    <label className="block text-gray-700 mb-2">
                      Last Name*
                    </label>
                    <input
                      required
                      type="text"
                      name="last_name"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-600"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-gray-700 mb-2">Email*</label>
                  <input
                    required
                    type="email"
                    name="email"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-600"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 mb-2">Phone</label>
                  <input
                    type="tel"
                    name="phone"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-600"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 mb-2">Subject*</label>
                  <input
                    required
                    type="text"
                    name="subject"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-600"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 mb-2">Message*</label>
                  <textarea
                    required
                    rows="4"
                    name="message"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-sky-600"
                  ></textarea>
                </div>

                <motion.button
                  whileHover={{ scale: 1.03 }}
                  whileTap={{ scale: 0.97 }}
                  type="submit"
                  disabled={loading}
                  className="w-full bg-gradient-to-r from-green-600 to-sky-600 hover:opacity-90 text-white py-3 rounded-lg font-semibold flex items-center justify-center shadow disabled:opacity-60"
                >
                  {loading
                    ? "Sending..."
                    : success
                    ? "Message Sent ✅"
                    : "Send Message"}
                  <FiSend className="ml-2" />
                </motion.button>
              </form>
            </div>
          </motion.div>
        </div>
      </section>

      {/* LOCATION MAP */}
      <section className="py-16 px-6 bg-gradient-to-br from-sky-50 to-white border-t border-gray-200">
        <div className="container mx-auto max-w-6xl">
          <motion.div
            initial="hidden"
            whileInView="visible"
            variants={fadeIn}
            viewport={{ once: true }}
            className="text-center mb-10"
          >
            <h2 className="text-3xl font-bold mb-3 text-green-700">
              Our Office in Hyderabad
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Visit us at our Hitech City office or connect remotely — our doors
              are open for collaborations across India.
            </p>
          </motion.div>
          <div className="rounded-xl overflow-hidden shadow-xl border border-sky-100">
            <iframe
              src={OFFICE_LOCATION}
              width="100%"
              height="430"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              title="Hyderabad Office Location Map"
              className="rounded-xl min-w-full min-h-[340px]"
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
